const statOrder = ['points', 'rebounds', 'assists', 'steals', 'blocks'];
const statLabel = { points: 'Points', rebounds: 'Rebounds', assists: 'Assists', steals: 'Steals', blocks: 'Blocks' };
const statLabelAbbv = { points: 'PPG', rebounds: 'RPG', assists: 'APG', steals: 'SPG', blocks: 'BPG' };

// Shared season leaders block used by both the current-season homepage and
// the seasons archive page, so the two stay visually identical without
// duplicating this markup.
const SeasonLeadersSection = ({ leaders }) => {
  if (!leaders || leaders.length === 0) return null;

  return (
    <div id="season-leaders" className="homepage-section">
      <p className="mini-title">Season Leaders</p>
      <div className="league-game-stats-container">
        {statOrder.map(stat => {
          const statLeaders = leaders.filter(l => l.stat === stat).slice(0, 10);
          if (statLeaders.length === 0) return null;
          return (
            <div key={stat} className="league-player-display">
              <p className="league-title-standard-small">{statLabel[stat]}</p>
              <div className="league-player-container">
                <div className="league-game-player-stats">
                  {statLeaders.map(leader => (
                    <div className="league-game-player-stat-group" key={leader.id + '-leader-' + leader.stat}>
                      <p className="league-game-player-name">
                        <a className="unstyled-link" href={`/players/${leader.id}`}>{leader.name}</a>
                        {' '}<span className="league-season-average-label">({leader.teamName})</span>
                      </p>
                      <p className="league-game-player-stat">
                        {parseFloat(leader.value.toFixed(1))} <span className="league-season-average-label">{statLabelAbbv[stat]}</span>
                      </p>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          );
        })}
      </div>
      <a href="/stats" className="homepage-anchor-link" style={{ display: 'block', marginTop: 10 }}>See Single Game Records</a>
      <a href="/records" className="homepage-anchor-link" style={{ display: 'block', marginTop: 10 }}>See All-time Records</a>
    </div>
  );
};

export default SeasonLeadersSection;
